import { Box, Button, Center, Text } from "@chakra-ui/react";
import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";
import { useMemo } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Href } from "../../components/Href";
import { PageLayout } from "../../components/PageLayout";
import { Splash } from "../../components/Splash";

export function Error404() {
  const intl = useIntl();

  const breadcrumbItems = useMemo(() => {
    /** @type {import("../../components/Breadcrumb").BreadcrumbItem[]} */
    const items = [
      {
        title: intl.formatMessage({ defaultMessage: "Accueil" }),
        url: generateFrontPath({
          id: "@front.home",
        }),
      },
    ];
    return items;
  }, [intl]);

  return (
    <PageLayout
      breadcrumbItems={breadcrumbItems}
      title={intl.formatMessage({ defaultMessage: "Erreur 404" })}>
      <Box px="1rem" py="3rem">
        <Splash
          title={intl.formatMessage({ defaultMessage: "Page introuvable" })}
          description={intl.formatMessage(
            {
              defaultMessage:
                "Nous sommes désolés, cette page n'existe pas ou a été supprimée.{br}Merci de vérifier cette adresse ou de retourner à l'accueil",
            },
            {
              br: <br />,
            },
          )}
          src={generateFrontPath({
            id: "@front.internal-assets",
            parameters: { filePath: "illustrations/page-not-found.svg" },
            includeBasePath: true,
          })}
          addon={
            <Center>
              <Href
                href={generateFrontPath({
                  id: "@front.home",
                })}>
                <Button
                  colorScheme="brandPrimary"
                  backgroundColor="brandPrimary.700">
                  <Text as="span" color="inherit">
                    <FormattedMessage defaultMessage="Retourner à l'accueil" />
                  </Text>
                </Button>
              </Href>
            </Center>
          }
        />
      </Box>
    </PageLayout>
  );
}
